import { useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";

import { SubscriptionAddons } from "@dashboard/shared/subscription/SubscriptionAddons";
import { SubscriptionLimits } from "@dashboard/shared/subscription/SubscriptionLimits";
import { Box, Theme } from "@mui/material";

import { PaneElement } from "../../shared/PaneElement";

import { ChangeLimitsModal } from "./ChangeLimitsModal";

const useStyles = makeStyles()((muiTheme: Theme) => ({
    emptyBox: {
        height: "100vh",
        margin: 0,
    },
    gridContainer: {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: muiTheme.spacing(2),
    },
}));

const LimitsTab = (props: {
    clientFeatures: API.Feature[] | null;
    clientId?: number;
    onLimitChange?: (limitType: string, newValue: number) => void;
    onAddonToggle?: (limitType: string, newValue: number) => void;
}) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["common", "pages"]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedLimitType, setSelectedLimitType] = useState<string>("");
    const [selectedLimitValue, setSelectedLimitValue] = useState<number>(0);

    const { clientFeatures, clientId, onLimitChange, onAddonToggle } = props;

    const handleTileClick = (limitType: string, currentLimit: number) => {
        setSelectedLimitType(limitType);
        setSelectedLimitValue(currentLimit);
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setSelectedLimitType("");
        setSelectedLimitValue(0);
    };

    const handleSuccess = (limitType: string, newValue: number) => {
        onLimitChange?.(limitType, newValue);
    };

    const handleToggle = (limitType: string, newValue: number) => {
        onAddonToggle?.(limitType, newValue);
    };

    if (!clientFeatures) {
        return (
            <PaneElement.Container>
                <PaneElement.Header>{t("common:limits.subscriptionLimits")}</PaneElement.Header>
                <Box className={classes.emptyBox} />
            </PaneElement.Container>
        );
    }

    return (
        <PaneElement.Container>
            <SubscriptionAddons features={clientFeatures || []} editable={true} onToggle={handleToggle} variant="pane" />
            <SubscriptionLimits features={clientFeatures || []} editable={true} onLimitClick={handleTileClick} variant="pane" />

            <ChangeLimitsModal
                open={modalOpen}
                onClose={handleModalClose}
                initialLimitType={selectedLimitType}
                initialValue={selectedLimitValue}
                clientId={clientId}
                onSuccess={handleSuccess}
            />
        </PaneElement.Container>
    );
};

export default LimitsTab;
